exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".swiper-container {\n  width: 100%;\n  height: 100%;\n  padding: 1px;\n}\n", ""]);

